export interface IModuleGraphI18n {
	readonly title: string;
	readonly locale: string;
	readonly labels: string;
	readonly legends: string;
	readonly descriptions: string;
}

export class ModuleGraphI18n implements IModuleGraphI18n {
	private _title: string;
	private _locale: string;
	private _labels: string;
	private _legends: string;
	private _descriptions: string;

	constructor(
		title: string,
		locale: string,
		labels: string,
		legends: string,
		descriptions: string
	) {
		this._title = title;
		this._locale = locale;
		this._labels = labels;
		this._legends = legends;
		this._descriptions = descriptions;
	}

	public get title(): string {
		return this._title;
	}

	public get locale(): string {
		return this._locale;
	}

	public get labels(): string {
		return this._labels;
	}

	public get legends(): string {
		return this._legends;
	}

	public get descriptions(): string {
		return this._descriptions;
	}
}
